import React, { useEffect, useState } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import Monthly_navbar from "./Monthlytasks_navbar";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import BusrouteDropDown from "../Shared/BusrouteDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";

const ManageVouchers = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const [sessionId, setSessionId] = useState(0);
  const [wingId, setWingId] = useState(0);
  const [classId, setClassId] = useState(0);
  const [sectionId, setSectionId] = useState(0);
  const [busRouteId, setBusRouteId] = useState(0);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);
  const [keywords, setKeywords] = useState("");

  useEffect(() => {
    document.title = "Manage Vouchers";
  }, []);

  useEffect(() => {
    loadRecords();
  }, [pageNo, pageSize, refreshKey]);

  const loadRecords = () => {
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      SessionID: sessionId,
      Wing_Id: wingId,
      Class_Id: classId,
      Section_Id: sectionId,
      BusRouteID: busRouteId,
      SelectedMonth: month,
      FYear: year,
      Keywords: keywords,
      pageNo: pageNo,
      pageSize: pageSize,
    };

    // Helpful for debugging request payload
    console.log("ManageVouchers request:", data);

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/GetChalanHeads",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

console.log(data);
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setLedger([]);
          setTotalRecords(0);
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleSearch = () => {
    setPageNo(1);
    setRefreshKey((prev) => prev + 1);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Challan_No}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>{item.Wing_Name}</td>
            <td>{item.Class_Name}</td>
            <td>{item.Section_Name}</td>
            <td>{item.Month}</td>
            <td>{item.Year}</td>
            <td>{item.Due_Date ? moment(item.Due_Date).format(config.date_format) : ""}</td>
            <td>{item.Due_Date_Amount}</td>
            <td>{item.Is_Paid ? "Paid" : "Unpaid"}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="13">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <Monthly_navbar />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/MonthlyTasks/MonthlyTasksDashboard">
                      Fee Posting
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage Vouchers
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Vouchers</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/MonthlyTasks/StartNewMonth"
                  className="button button-white button-icon"
                >
                  Post Fee
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <div className="row g-2 align-items-end">
                <div className="col-md-2">
                  <label className="form-label">Session</label>
                  <select
                    className="form-select"
                    value={sessionId}
                    onChange={(e) => {
                      setSessionId(parseInt(e.target.value));
                      setClassId(0);
                      setSectionId(0);
                    }}
                  >
                    <option value="0">--All--</option>
                    <SessionsDropDown selectedSession={sessionId} />
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Wing</label>
                  <select
                    className="form-select"
                    value={wingId}
                    onChange={(e) => {
                      setWingId(parseInt(e.target.value));
                      setClassId(0);
                      setSectionId(0);
                    }}
                  >
                    <option value="0">--All--</option>
                    <WingsDropDown selectedWingId={wingId} />
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Class</label>
                  <select
                    className="form-select"
                    value={classId}
                    onChange={(e) => {
                      setClassId(parseInt(e.target.value));
                      setSectionId(0);
                    }}
                  >
                    <option value="0">--All--</option>
                    <ClassesDropDown
                      WingID={wingId}
                      SessionID={sessionId}
                      selectedClassId={classId}
                    />
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Section</label>
                  <select
                    className="form-select"
                    value={sectionId}
                    onChange={(e) => setSectionId(parseInt(e.target.value))}
                  >
                    <option value="0">--All--</option>
                    <SectionDropDown
                      ClassID={classId}
                      selectedSectionId={sectionId}
                    />
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Transport</label>
                  <select
                    className="form-select"
                    value={busRouteId}
                    onChange={(e) => setBusRouteId(parseInt(e.target.value))}
                  >
                    <option value="0">--All--</option>
                    <option value="-2">Transport Only</option>
                    <BusrouteDropDown selectedRoot_ID={busRouteId} />
                  </select>
                </div>
                <div className="col-md-1">
                  <label className="form-label">Month</label>
                  <select
                    className="form-select"
                    value={month}
                    onChange={(e) => setMonth(parseInt(e.target.value))}
                  >
                    <option value="0">--All--</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((m) => (
                      <option value={m} key={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-1">
                  <label className="form-label">Year</label>
                  <input
                    type="number"
                    className="form-control"
                    value={year === 0 ? "" : year}
                    onChange={(e) =>
                      setYear(e.target.value ? parseInt(e.target.value) : 0)
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Search</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Reg No, Challan No, Student"
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <button
                    onClick={handleSearch}
                    className="button button-primary w-100"
                  >
                    Search
                  </button>
                </div>
              </div>

              <div className="mt-4">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Challan No</th>
                      <th>Reg No</th>
                      <th>Student</th>
                      <th>Father</th>
                      <th>Wing</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Due Date</th>
                      <th>Due Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="13">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                </table>

                {totalRecords > pageSize && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value));
                              }}
                              value={pageSize}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default ManageVouchers;
